/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr, hasMany, type AsyncHasMany } from '@warp-drive/legacy/model';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';
import type Media from '@linc-technologies/linced-common/models/media';
import moment from 'moment';
import Post from './post';

export default class Attendancenote extends Post {
  declare [Type]: 'posts/attendancenote';

  postType = PostTypes.ATTENDANCE_NOTE;

  // Attendance Notes don't support comments/reactions.
  @attr()
  // @ts-expect-error A plain attr replaces the Post comments hasMany.
  declare comments: unknown;

  @attr()
  // @ts-expect-error A plain attr replaces the Post reactions hasMany.
  declare reactions: unknown;

  @hasMany('media', { async: true, inverse: 'attendanceNoteId' })
  declare mediaIds: AsyncHasMany<Media>;

  // Don't trigger the Person reloads which the base Post model does.
  reloadPersonOnSave = false;

  // Date for which this attendance note applies
  // Take the display date on the record and shift it by 9 hours
  // This give us a 3pm cutoff
  // date falls back to createTime. A saved note has a createTime.
  @computed('date')
  get attendanceDate() {
    return moment.unix(this.date!).add(9, 'hours').format('YYYY-MM-DD');
  }
}
